import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ISite } from '../../../Store/sites.state/sites.model';
import { AppState } from '../../../Store/app.state/app.state';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'ins-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', './../shared/header-shared-design.scss'],
    imports: [MatIcon]
})
export class HeaderComponent {

  logoutToggleIndex$: Observable<number>;

  intoSiteLogoPath: string = `${environment.baseHref}/assets/app.intosite-logo.png`;

  @Input() siteName: string = '';

  constructor(private store: Store) {
    this.logoutToggleIndex$ = this.store.select(AppState.getLogoutToggleIndex);
    this.logoutToggleIndex$.subscribe((index: number) => {
      if (index > 0) {
        this.siteName = '';
      }
    });
  }

}
